import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip, type TooltipProps } from "antd";

import { colors } from "../../lib/constants/colors";

export function HelpTooltip({
  disabled,
  children,
  styles,
  placement = "right",
  ...props
}: TooltipProps & { disabled?: boolean }) {
  if (disabled) return <>{children}</>;

  const tooltipStyles =
    typeof styles === "function"
      ? styles
      : {
          ...styles,
          root: {
            maxWidth: "30vw",
            whiteSpace: "pre-line" as const,
            ...styles?.root,
          },
          container: styles?.container,
        };

  return (
    <Tooltip
      trigger={["focus"]}
      placement={placement}
      color={colors.aragroColor}
      styles={tooltipStyles}
      {...props}
      align={
        placement === "right"
          ? { offset: [12, 16], ...props.align }
          : props.align
      }
    >
      {/*
       * Wrap in a div so antd v6 Tooltip can attach a DOM ref. Most call sites
       * pass <Form.Item> (a function component without forwardRef), which
       * leaves @rc-component/trigger without a target to measure — the popup
       * gets stranded at -1000vh/-1000vw and appears as a flicker on focus.
       */}
      <div>{children}</div>
    </Tooltip>
  );
}

export function HintTooltip(props: TooltipProps) {
  return (
    <Tooltip {...props}>
      <QuestionCircleOutlined style={{ opacity: 0.5 }} />
    </Tooltip>
  );
}
